import actions from './actions';

const { requestCharactersBegin } = actions;

export default {
  requestCharactersBegin,
};
